import { string } from 'prop-types';
import React, { useState } from 'react';

import ImageSearchModal from '@features/trend-research/components/common/imageSearch/ImageSearchModal';

import { useExploreProductsSource } from '@store/reducers/trend-research/TrendResearchReducer';

const ProductTopSection = ({ title = 'No Title' }) => {
	const [isShowImageSearch, setIsShowImageSearch] = useState(false);
	const sourceType = useExploreProductsSource();

	const toggleImageSearchModal = (isShow) => {
		setIsShowImageSearch(isShow);
	};

	return (
		<div className="section-title d-flex align-items-center justify-content-between">
			<p className="semibold-16 gray_dark_01 w-100">{title}</p>
			<div className="product-search-action d-flex align-items-center">
				<div className="search-img cursor-pointer">
					<img
						src={`${process.env.PUBLIC_URL}/icons/camera.svg`}
						alt=""
						onClick={() => toggleImageSearchModal(true)}
					/>
				</div>
			</div>
			{isShowImageSearch && (
				<ImageSearchModal onClose={() => toggleImageSearchModal(false)} sourceType={sourceType} />
			)}
		</div>
	);
};

ProductTopSection.propTypes = {
	title: string.isRequired
};

export default ProductTopSection;
